import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';

import { getLoggedUserInfo } from './api';

export function useLoggedUserInfo() {
    const { inProgress, accounts } = useMsal();

    const enabled = inProgress === InteractionStatus.None && accounts.length > 0;

    return useQuery({
        queryKey: ['loggedUserInfo'],
        queryFn: getLoggedUserInfo,
        enabled,
    });
}
